import { render, staticRenderFns } from "./epros-details.vue?vue&type=template&id=22a1a294&scoped=true&"
import script from "./epros-details.vue?vue&type=script&lang=js&"
export * from "./epros-details.vue?vue&type=script&lang=js&"
import style0 from "./epros-details.vue?vue&type=style&index=0&id=22a1a294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a1a294",
  null
  
)

component.options.__file = "epros-details.vue"
export default component.exports